import { Button, Col, Row } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import {
  getProjectSharedFiles,
  uploadProjectSharedFiles,
} from '../../api/constlink';
import UploadProjectSharedFileModal from '../../components/projects/UploadProjectSharedFileModal';
import {
  getProjectSharedFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';
interface ProjectSharedFileListContainerProps {
  enterpriseId: string;
  projectId: string;
}
function ProjectSharedFileListContainer({
  history,
  match,
}: RouteComponentProps<ProjectSharedFileListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const [projectSharedFiles, setProjectSharedFiles] = useState<UploadFile[]>(
    [],
  );
  const [visible, setVisible] = useState(false);
  const [uploadProps, setUploadProps] = useState<any>();

  useEffect(() => {
    (async () => {
      setProjectSharedFiles(
        await getProjectSharedFiles({ enterpriseId, projectId }),
      );
    })();
    setProjectSharedFiles([]);
    (async () => {
      setUploadProps(
        await initializeUploadProps(
          getProjectSharedFileAPIPath(enterpriseId, projectId),
        ),
      );
    })();
  }, [enterpriseId, projectId]);

  // const onDelete = async (sharedFileId: number) => {
  //   setProjectSharedFiles(
  //     await removeProjectSharedFile({
  //       enterpriseId,
  //       projectId,
  //       sharedFileId,
  //     }),
  //   );
  // };

  const onCancel = () => {
    setVisible(false);
  };

  const onUpload = async (data: any) => {
    for (const file of data.file) {
      file.path = file.response.path;
      file.mimeType = file.response.mimeType;
    }

    setVisible(false);
    setProjectSharedFiles(
      await uploadProjectSharedFiles({
        enterpriseId,
        projectId,
        file: data.file,
      }),
    );
  };

  // const _downloadFile = async (attachFileId: string, fileName: string) => {
  //   await downloadFile(
  //     getProjectSharedFileAPIPath(enterpriseId, projectId),
  //     attachFileId,
  //     fileName,
  //   );
  // };

  return (
    <>
      <Row justify="space-between">
        <Col>
          <h2>공유 파일 리스트</h2>
        </Col>
        <Col>
          <Button
            onClick={() => {
              setVisible(true);
            }}
          >
            파일 올리기
          </Button>
        </Col>
      </Row>

      {/* {projectSharedFiles.length !== 0 && (
        <ProjectSharedFileListComponent
          file={projectSharedFiles}
          onDelete={onDelete}
          donwloadFile={_downloadFile}
        />
      )} */}
      {projectSharedFiles.length === 0 && (
        <>
          <Row justify="center" align="middle" style={{ minHeight: '60vh' }}>
            <Col>
              <span style={{ fontSize: '30px' }}>설계 도서를 공유 하세요.</span>
            </Col>
          </Row>
        </>
      )}
      <UploadProjectSharedFileModal
        visible={visible}
        uploadProps={uploadProps}
        onUpload={onUpload}
        onCancel={onCancel}
      />
    </>
  );
}

export default ProjectSharedFileListContainer;
